var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path0, _path1, _path10, _g3, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomersEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 321,
    viewBox: "0 0 382 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_979_1526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.515 206.043H134.355C129.914 206.043 126.318 202.448 126.318 198.006V55.1432C126.318 50.7018 129.914 47.1064 134.355 47.1064H238.515C242.956 47.1064 246.552 50.7018 246.552 55.1432V198.006C246.552 202.448 242.956 206.043 238.515 206.043Z",
    fill: "url(#paint0_linear_979_1526)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.971 167.499H172.9C169.886 167.499 167.454 165.067 167.454 162.053C167.454 159.04 169.886 156.607 172.9 156.607H199.971C202.985 156.607 205.417 159.04 205.417 162.053C205.417 165.067 202.985 167.499 199.971 167.499Z",
    fill: "#E4DAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.396 179.289H160.422C158.835 179.289 157.566 178.02 157.566 176.434C157.566 174.848 158.835 173.579 160.422 173.579H212.396C213.982 173.579 215.251 174.848 215.251 176.434C215.251 177.968 213.982 179.289 212.396 179.289Z",
    fill: "#E4DAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.966 103.787C221.966 114.467 217.26 124.037 209.805 130.541C203.566 135.986 195.371 139.265 186.435 139.265C177.499 139.265 169.304 135.986 163.065 130.488C155.61 123.984 150.904 114.414 150.904 103.734C150.904 84.1179 166.819 68.2031 186.435 68.2031C206.051 68.2031 221.966 84.1708 221.966 103.787Z",
    fill: "#C8B5F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M209.805 130.54C203.566 135.986 195.371 139.264 186.435 139.264C177.5 139.264 169.304 135.986 163.065 130.487C165.656 129.483 169.04 128.161 173.587 126.31C174.645 125.887 175.438 125.094 175.914 124.09C176.178 123.508 176.284 122.926 176.284 122.292V113.779C176.125 113.621 176.019 113.409 175.914 113.251C175.173 112.14 174.698 110.871 174.539 109.549L173.799 109.179C171.631 109.708 171.79 107.382 171.208 102.887C170.996 101.037 171.261 100.667 172.107 100.35L172.794 99.3979C168.564 89.8807 170.679 83.906 174.856 81.7911C173.481 78.7773 173.376 77.667 173.376 77.667C173.376 77.667 182.258 79.1474 185.272 78.5658C189.132 77.7727 195.107 78.7245 197.327 83.8531C201.028 85.2807 202.456 87.66 202.773 90.1451C203.09 92.4715 202.403 95.0094 201.716 96.9657C201.663 97.1243 201.61 97.2301 201.557 97.3358C201.557 97.3887 201.504 97.4415 201.504 97.4944C201.398 97.7588 201.346 97.9703 201.24 98.1818C201.187 98.2875 201.187 98.3933 201.134 98.499C201.081 98.7105 200.975 98.922 200.923 99.0806C200.923 99.1335 200.923 99.1335 200.87 99.1864C200.817 99.345 200.764 99.5036 200.711 99.6622C200.658 99.8737 200.605 100.032 200.552 100.191C200.605 100.244 200.605 100.35 200.658 100.402C201.24 100.667 201.451 101.196 201.24 102.835C200.711 107.117 200.87 109.708 198.649 109.127L196.693 112.51C196.64 112.881 196.587 113.092 196.534 113.303C196.481 113.938 196.481 115.207 196.481 122.186C196.481 123.032 196.746 123.825 197.169 124.513C197.644 125.253 198.332 125.887 199.178 126.257C199.178 126.257 199.231 126.257 199.231 126.31C203.831 128.267 207.215 129.536 209.805 130.54Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.605 100.244C200.764 99.1864 200.288 97.8117 199.918 96.9128C199.865 96.7542 199.759 96.5956 199.707 96.437C198.015 93.0531 194.208 91.6255 190.612 91.414C181.412 90.9381 180.514 92.683 177.658 90.0393C178.557 91.3611 178.61 93.5289 177.235 96.1726C176.284 98.0231 174.433 98.8691 172.741 99.3979C168.511 89.8807 170.626 83.906 174.803 81.7911C173.429 78.7773 173.323 77.667 173.323 77.667C173.323 77.667 182.205 79.1474 185.219 78.5658C189.079 77.7727 195.054 78.7245 197.274 83.8531C200.975 85.2807 202.403 87.66 202.72 90.1451C203.355 94.1105 201.028 98.499 200.605 100.244Z",
    fill: "url(#paint1_linear_979_1526)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.221 124.618V126.257H175.86V124.089C176.125 123.508 176.23 122.926 176.23 122.292V113.779C176.072 113.621 175.966 113.409 175.86 113.25V112.722C176.336 113.515 176.918 114.202 177.605 114.837L184.267 119.542C185.8 120.864 188.074 120.864 189.66 119.595L195.899 113.991C196.111 113.832 196.322 113.621 196.534 113.409C196.481 114.044 196.481 115.312 196.481 122.292C196.587 123.138 196.798 123.931 197.221 124.618Z",
    fill: "url(#paint2_linear_979_1526)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_979_1526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.027 181.457H30.0367C25.5954 181.457 22 177.862 22 173.42V79.7291C22 75.2878 25.5954 71.6924 30.0367 71.6924H97.027C101.468 71.6924 105.064 75.2878 105.064 79.7291V173.473C105.064 177.915 101.468 181.457 97.027 181.457Z",
    fill: "url(#paint3_linear_979_1526)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8637 154.862H54.1466C52.0845 154.862 50.3926 153.171 50.3926 151.108C50.3926 149.046 52.0845 147.354 54.1466 147.354H72.8637C74.9257 147.354 76.6177 149.046 76.6177 151.108C76.6177 153.171 74.9257 154.862 72.8637 154.862Z",
    fill: "#E4DAFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4822 163.004H45.5813C44.471 163.004 43.625 162.106 43.625 161.048C43.625 159.938 44.5238 159.092 45.5813 159.092H81.4822C82.5925 159.092 83.4385 159.991 83.4385 161.048C83.4385 162.106 82.5396 163.004 81.4822 163.004Z",
    fill: "#E4DAFC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0389 110.819C88.0389 118.222 84.7608 124.831 79.6321 129.325C75.2965 133.079 69.692 135.352 63.5058 135.352C57.3196 135.352 51.6622 133.079 47.3795 129.325C42.2508 124.831 38.9727 118.222 38.9727 110.819C38.9727 97.2837 49.9703 86.2861 63.5058 86.2861C77.0413 86.2861 88.0389 97.2837 88.0389 110.819Z",
    fill: "#FCDEB1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6315 129.326C75.2959 133.08 69.6914 135.354 63.5052 135.354C57.3191 135.354 51.6616 133.08 47.3789 129.326C49.1766 128.639 51.503 127.74 54.6225 126.418C55.3628 126.101 55.8915 125.572 56.2087 124.885C56.3673 124.515 56.4731 124.092 56.4731 123.616V117.747C56.3673 117.641 56.2616 117.483 56.2087 117.377C55.68 116.637 55.3628 115.738 55.257 114.839L54.7283 114.575C53.2478 114.945 53.3536 113.306 52.9306 110.239C52.772 108.97 52.9835 108.706 53.5122 108.494L53.988 107.86C51.08 101.251 52.5605 97.1265 55.4156 95.6989C54.4639 93.6369 54.411 92.8438 54.411 92.8438C54.411 92.8438 60.5443 93.8483 62.6592 93.4782C65.3558 92.9495 69.427 93.584 70.9603 97.1265C73.4982 98.1311 74.5028 99.7701 74.7143 101.462C74.9258 103.101 74.45 104.793 74.027 106.168C73.9741 106.274 73.9741 106.326 73.9212 106.432C73.9212 106.485 73.8683 106.485 73.8683 106.538C73.8155 106.697 73.7626 106.855 73.7097 107.014C73.6569 107.067 73.6569 107.172 73.604 107.225C73.5511 107.384 73.4982 107.49 73.4454 107.648V107.701C73.3925 107.807 73.3396 107.913 73.3396 108.018C73.2867 108.177 73.2339 108.283 73.2339 108.388C73.2867 108.441 73.2867 108.494 73.2867 108.547C73.7097 108.759 73.8155 109.076 73.6569 110.186C73.2867 113.147 73.3925 114.945 71.8592 114.522L70.5373 116.901C70.4845 117.165 70.4316 117.271 70.4316 117.483C70.3787 117.906 70.3787 118.804 70.3787 123.616C70.3787 124.198 70.5373 124.726 70.8546 125.202C71.1718 125.731 71.6477 126.154 72.2293 126.365H72.2822C75.5603 127.74 77.8867 128.639 79.6315 129.326Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3398 108.387C73.4455 107.646 73.1283 106.748 72.8639 106.06C72.811 105.954 72.7582 105.849 72.7053 105.743C71.5421 103.417 68.8984 102.412 66.4134 102.306C60.0686 101.989 59.4341 103.205 57.4778 101.355C58.1123 102.306 58.1652 103.734 57.2135 105.584C56.5261 106.853 55.2572 107.435 54.1468 107.805C51.2388 101.196 52.7193 97.0718 55.5744 95.6442C54.6227 93.5822 54.5698 92.7891 54.5698 92.7891C54.5698 92.7891 60.7031 93.7937 62.818 93.4235C65.5146 92.8948 69.5858 93.5293 71.1191 97.0718C73.657 98.0764 74.6616 99.7154 74.8731 101.407C75.1903 104.157 73.6041 107.171 73.3398 108.387Z",
    fill: "url(#paint4_linear_979_1526)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0133 125.253V126.416H56.2617V124.883C56.4203 124.513 56.5261 124.09 56.5261 123.614V117.745C56.4203 117.639 56.3146 117.481 56.2617 117.375V117.058C56.579 117.586 57.0019 118.115 57.4778 118.485L62.0778 121.71C63.1352 122.609 64.7214 122.662 65.8318 121.763L70.1674 117.904C70.326 117.798 70.4846 117.639 70.5903 117.481C70.5375 117.904 70.5375 118.802 70.5375 123.614C70.5375 124.195 70.6961 124.777 71.0133 125.253Z",
    fill: "url(#paint5_linear_979_1526)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_979_1526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.248 181.457H274.257C269.816 181.457 266.221 177.862 266.221 173.42V79.7291C266.221 75.2878 269.816 71.6924 274.257 71.6924H341.248C345.689 71.6924 349.284 75.2878 349.284 79.7291V173.473C349.284 177.915 345.689 181.457 341.248 181.457Z",
    fill: "url(#paint6_linear_979_1526)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M317.085 154.862H298.368C296.306 154.862 294.614 153.171 294.614 151.108C294.614 149.046 296.306 147.354 298.368 147.354H317.085C319.147 147.354 320.839 149.046 320.839 151.108C320.892 153.171 319.2 154.862 317.085 154.862Z",
    fill: "#E4DAFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M325.704 163.004H289.803C288.693 163.004 287.847 162.106 287.847 161.048C287.847 159.938 288.746 159.092 289.803 159.092H325.704C326.814 159.092 327.66 159.991 327.66 161.048C327.66 162.106 326.814 163.004 325.704 163.004Z",
    fill: "#E4DAFC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M332.312 110.819C332.312 118.222 329.034 124.831 323.906 129.325C319.57 133.079 313.965 135.352 307.779 135.352C301.593 135.352 295.936 133.079 291.653 129.325C286.524 124.831 283.246 118.222 283.246 110.819C283.246 97.2837 294.244 86.2861 307.779 86.2861C321.315 86.2861 332.312 97.2837 332.312 110.819Z",
    fill: "#A3DFBC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M323.906 129.326C319.57 133.08 313.966 135.354 307.78 135.354C301.593 135.354 295.936 133.08 291.653 129.326C293.451 128.639 295.777 127.74 298.897 126.418C299.637 126.101 300.166 125.572 300.483 124.885C300.642 124.515 300.748 124.092 300.748 123.616V117.747C300.642 117.641 300.536 117.483 300.483 117.377C299.954 116.637 299.637 115.738 299.531 114.839L299.003 114.575C297.522 114.945 297.628 113.306 297.205 110.239C297.046 108.97 297.258 108.706 297.787 108.494L298.262 107.86C295.354 101.251 296.835 97.1265 299.69 95.6989C298.738 93.6369 298.685 92.8438 298.685 92.8438C298.685 92.8438 304.819 93.8483 306.934 93.4782C309.63 92.9495 313.701 93.584 315.235 97.1265C317.773 98.1311 318.777 99.7701 318.989 101.462C319.2 103.101 318.724 104.793 318.301 106.168C318.249 106.274 318.248 106.326 318.196 106.432C318.196 106.485 318.143 106.485 318.143 106.538C318.09 106.697 318.037 106.855 317.984 107.014C317.931 107.067 317.931 107.172 317.878 107.225C317.825 107.384 317.773 107.49 317.72 107.648V107.701C317.667 107.807 317.614 107.913 317.614 108.018C317.561 108.177 317.508 108.283 317.508 108.388C317.561 108.441 317.561 108.494 317.561 108.547C317.984 108.759 318.09 109.076 317.931 110.186C317.561 113.147 317.667 114.945 316.134 114.522L314.812 116.901C314.759 117.165 314.706 117.271 314.706 117.483C314.653 117.906 314.653 118.804 314.653 123.616C314.653 124.198 314.812 124.726 315.129 125.202C315.446 125.731 315.922 126.154 316.504 126.365H316.557C319.782 127.74 322.108 128.639 323.906 129.326Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M317.561 108.387C317.667 107.646 317.35 106.748 317.086 106.06C317.033 105.954 316.98 105.849 316.927 105.743C315.764 103.417 313.12 102.412 310.635 102.306C304.29 101.989 303.656 103.205 301.7 101.355C302.334 102.306 302.387 103.734 301.435 105.584C300.748 106.853 299.479 107.435 298.369 107.805C295.46 101.196 296.941 97.0718 299.796 95.6442C298.844 93.5822 298.791 92.7891 298.791 92.7891C298.791 92.7891 304.925 93.7937 307.04 93.4235C309.736 92.8948 313.807 93.5293 315.341 97.0718C317.879 98.0764 318.883 99.7154 319.095 101.407C319.412 104.157 317.879 107.171 317.561 108.387Z",
    fill: "url(#paint7_linear_979_1526)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M315.235 125.253V126.416H300.483V124.883C300.642 124.513 300.748 124.09 300.748 123.614V117.745C300.642 117.639 300.536 117.481 300.483 117.375V117.058C300.801 117.586 301.224 118.115 301.699 118.485L306.299 121.71C307.357 122.609 308.943 122.662 310.053 121.763L314.389 117.904C314.548 117.798 314.706 117.639 314.812 117.481C314.759 117.904 314.759 118.802 314.759 123.614C314.759 124.195 314.918 124.777 315.235 125.253Z",
    fill: "url(#paint8_linear_979_1526)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M328.718 282.286L261.833 215.454L277.166 200.121L343.998 267.006L328.718 282.286Z",
    fill: "#15112D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M362.027 315.861L310.74 264.574C306.458 260.291 306.458 253.312 310.74 249.029C315.023 244.747 322.002 244.747 326.285 249.029L377.572 300.316C381.855 304.599 381.855 311.578 377.572 315.861C373.289 320.144 366.31 320.144 362.027 315.861Z",
    fill: "#15112D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M358.379 319.139L292.393 253.153C290.86 251.62 290.86 249.135 292.393 247.549L309.26 230.682C310.793 229.149 313.278 229.149 314.864 230.682L380.85 296.668C382.383 298.201 382.383 300.686 380.85 302.272L363.983 319.139C362.397 320.672 359.912 320.672 358.379 319.139Z",
    fill: "#7647EE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M186.118 0.102539C116.114 0.102539 59.3809 56.8354 59.3809 126.839C59.3809 196.791 116.114 253.576 186.065 253.576C256.069 253.576 312.802 196.843 312.802 126.839C312.802 56.8354 256.069 0.102539 186.118 0.102539ZM186.118 230.101C129.914 230.101 84.3899 183.837 84.3899 126.787C84.3899 69.7365 129.914 23.5253 186.118 23.5253C242.322 23.5253 287.846 69.7893 287.846 126.839C287.846 183.89 242.269 230.101 186.118 230.101Z",
    fill: "#696677"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_979_1526",
    x: 104.318,
    y: 36.1064,
    width: 164.233,
    height: 202.937,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_979_1526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_979_1526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_979_1526",
    x: 0,
    y: 60.6924,
    width: 127.063,
    height: 153.765,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_979_1526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_979_1526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_979_1526",
    x: 244.221,
    y: 60.6924,
    width: 127.063,
    height: 153.765,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_979_1526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_979_1526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_979_1526",
    x1: 186.396,
    y1: 43.4301,
    x2: 186.396,
    y2: 207.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_979_1526",
    x1: 170.418,
    y1: 88.9579,
    x2: 202.835,
    y2: 88.9579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_979_1526",
    x1: 186.547,
    y1: 126.34,
    x2: 186.547,
    y2: 118.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_979_1526",
    x1: 63.5048,
    y1: 69.1534,
    x2: 63.5048,
    y2: 182.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_979_1526",
    x1: 52.5571,
    y1: 100.59,
    x2: 74.9189,
    y2: 100.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_979_1526",
    x1: 63.642,
    y1: 126.473,
    x2: 63.642,
    y2: 121.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_979_1526",
    x1: 307.725,
    y1: 69.1534,
    x2: 307.725,
    y2: 182.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_979_1526",
    x1: 296.779,
    y1: 100.59,
    x2: 319.142,
    y2: 100.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_979_1526",
    x1: 307.864,
    y1: 126.473,
    x2: 307.864,
    y2: 121.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E5EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersEmptyState);
export default __webpack_public_path__ + "static/media/customers-empty-state.360dda25a1439ee2601aa1078e51aa6e.svg";
export { ForwardRef as ReactComponent };